import { CameraType } from '@/types/sensor/configuration.types';
import { SensorTypeEnum } from '@/types/sensor/sensors';

export const cameraRange: Record<CameraType, number> = {
  [SensorTypeEnum.AF2206]: 7000,
  [SensorTypeEnum.ZMER]: 3000,
  [SensorTypeEnum.ONVIF]: 3000,
  [SensorTypeEnum.AXIS]: 3000,
};

export enum HolopticsSubCameraEnum {
  PC,
  GC,
  SWIR,
  MWIR,
}

enum ZmerSubCameraEnum {
  DAY,
  IR,
}

enum AxisSubCameraEnum {
  DAY,
}

export type SubCameraType = HolopticsSubCameraEnum | ZmerSubCameraEnum | AxisSubCameraEnum;

type SubCameraFeatureType = boolean | SubCameraType[];

export type CameraAvailableFeatures = {
  zoom?: boolean;
  focus?: SubCameraFeatureType;
  roundOn?: boolean;
  autoFocus?: SubCameraFeatureType;
  autoFocusPerm?: boolean;
  iso?: SubCameraFeatureType;
  polarity?: SubCameraFeatureType;
  deIcing?: SubCameraFeatureType;
  whiteBalance?: SubCameraFeatureType;
  hybridFocus?: SubCameraFeatureType;
  zoomSync?: boolean;
  nuc?: SubCameraFeatureType;
  parkingPosition?: boolean;
  factoryPosition?: boolean;
  mwirFilters?: SubCameraFeatureType;
  activateIr?: SubCameraFeatureType;
};

export const subCamera: Record<CameraType, { name: string; type: SubCameraType; fluxId: number }[]> = {
  [SensorTypeEnum.AF2206]: [
    { name: 'PC', type: HolopticsSubCameraEnum.PC, fluxId: 0 },
    { name: 'GC', type: HolopticsSubCameraEnum.GC, fluxId: 1 },
    { name: 'SWIR', type: HolopticsSubCameraEnum.SWIR, fluxId: 2 },
    { name: 'MWIR', type: HolopticsSubCameraEnum.MWIR, fluxId: 3 },
  ],
  [SensorTypeEnum.AXIS]: [{ name: 'DAY', type: AxisSubCameraEnum.DAY, fluxId: 0 }],
  [SensorTypeEnum.ZMER]: [
    { name: 'DAY', type: ZmerSubCameraEnum.DAY, fluxId: 0 },
    { name: 'IR', type: ZmerSubCameraEnum.IR, fluxId: 1 },
  ],
  [SensorTypeEnum.ONVIF]: [],
};

export const cameraAvailableFeatures: Record<CameraType, CameraAvailableFeatures> = {
  [SensorTypeEnum.AF2206]: {
    zoom: true,
    focus: [HolopticsSubCameraEnum.PC, HolopticsSubCameraEnum.GC],
    roundOn: true,
    autoFocus: true,
    autoFocusPerm: true,
    iso: [HolopticsSubCameraEnum.PC, HolopticsSubCameraEnum.GC],
    polarity: [HolopticsSubCameraEnum.SWIR, HolopticsSubCameraEnum.MWIR],
    deIcing: [HolopticsSubCameraEnum.PC, HolopticsSubCameraEnum.GC, HolopticsSubCameraEnum.SWIR],
    whiteBalance: [HolopticsSubCameraEnum.PC, HolopticsSubCameraEnum.GC],
    hybridFocus: [HolopticsSubCameraEnum.SWIR, HolopticsSubCameraEnum.MWIR],
    zoomSync: true,
    nuc: [HolopticsSubCameraEnum.MWIR],
    parkingPosition: true,
    factoryPosition: true,
    mwirFilters: [HolopticsSubCameraEnum.MWIR],
  },
  [SensorTypeEnum.AXIS]: {
    zoom: true,
    focus: true,
    roundOn: true,
    autoFocus: true,
    autoFocusPerm: true,
    parkingPosition: true,
    factoryPosition: true,
    activateIr: [AxisSubCameraEnum.DAY],
  },
  [SensorTypeEnum.ZMER]: {
    zoom: true,
    focus: true,
    roundOn: true,
    autoFocus: true,
    autoFocusPerm: true,
    zoomSync: true,
  },
  [SensorTypeEnum.ONVIF]: {},
};

export const MAX_FOCUS_PRESET = 20;
